import { Parser } from "./Parser";

export abstract class ParserPhase<P extends Parser>
{
  #parser:P;
  
  get parser(){ return this.#parser; }
  
  abstract get phaseInfo():string;

  constructor( parser:P )
  {
    this.#parser = parser;
    this.#parser._add( this );
  }

  reset(){}

  abstract process():void;

} 